// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { BadgeTypeValues } from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import xUseWidgetBadges from "@pacific/App/Hooks/xUseWidgetBadges";
import { XBadgeModel } from "@pacific/XDL/types";
import { sharedBadgesContainerStyles } from "@pacific/XDL/Utilities";
import { css } from "styled-components";

interface Props {
    productContext: ProductContextModel;
    showTextBadge?: boolean;
    showImageBadge?: boolean;
    styles?: { badgeTextWrapper?: InjectableCss; badgeImageWrapper?: InjectableCss };
    largeImageBadgePositioning?: boolean;
}

const xUseOverlayBadge = ({
    productContext,
    showTextBadge,
    showImageBadge,
    styles,
    largeImageBadgePositioning,
}: Props) => {
    let overlayBadgesWrapperStyles = null;
    const { textBadges, imageBadges } = xUseWidgetBadges({
        productContext,
        showTextBadges: showTextBadge,
        showImageBadges: showImageBadge,
    });

    const badges: XBadgeModel[] = [...(textBadges || []), ...(imageBadges || [])];

    let visibleBadges = badges.filter(badge => badge.displayOnProductImages);

    if (!showImageBadge && visibleBadges.length > 0) {
        visibleBadges = visibleBadges.filter(badge => badge.badgeType !== BadgeTypeValues.Image);
    }

    if (!showTextBadge && visibleBadges.length > 0) {
        visibleBadges = visibleBadges.filter(badge => badge.badgeType !== BadgeTypeValues.Text);
    }
    overlayBadgesWrapperStyles = {
        css: css`
            ${largeImageBadgePositioning
                ? "top: 12px; left: 16px; min-width: 166px;"
                : "bottom: 0; left: 0; width: 100%;"}
            position: absolute;
            ${sharedBadgesContainerStyles}
        `,
    };
    return {
        showOverlayBadge: visibleBadges.length > 0,
        overlayBadges: visibleBadges,
        overlayBadgesWrapperStyles,
    };
};

// eslint-disable-next-line spire/export-styles
export default xUseOverlayBadge;
